import React, {useEffect, useRef} from 'react';
import {useNavigate } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Button, Grid, Typography} from "@mui/material";
import { handleLogout } from "../index";

export const Logout = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector(store => store.auth);
    const hasLoggedOut = useRef(false);

    useEffect(() => {
        if (auth.isLoggedIn && !hasLoggedOut.current) {
            hasLoggedOut.current = true;
            handleLogout(dispatch);
        }
    }, [auth.isLoggedIn, dispatch]);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    align={"center"}
                    mb={4}
                    fontWeight={"bold"}
                    className={"title"}
                    variant={"h1"}
                >
                    You have been logged out.
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2} sx={{ py: 2 }}>
                    <Grid item xs={12}>
                        <Typography align="center" variant="body1">
                            Your session has ended.
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            fullWidth={true}
                            color="primary"
                            variant="contained"
                            disableElevation={true}
                            onClick={() => navigate(`/login`)}
                            size="large"
                            sx={{ height: 50, fontSize: 18, textTransform: "capitalize" }}
                        >
                            Sign In
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}